import { render, staticRenderFns } from "./SectionContentWrapper.vue?vue&type=template&id=6595f021"
import script from "./SectionContentWrapper.vue?vue&type=script&lang=js"
export * from "./SectionContentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports